export type PublicLinkDomain = {
  domain_url: string;
  public_url?: string | null;
};

/**
 * Outward link base for a domain: prefer the optional public_url (set for
 * custom domains reverse-proxied from the customer's own website, where
 * domain_url must stay the routing host and cannot double as the public
 * address) and fall back to domain_url. Mirrors the backend precedence in
 * career-sites-server's canonical_domain_url.
 */
export const getPublicLinkBase = (domain?: PublicLinkDomain): string => {
  const base = domain?.public_url || domain?.domain_url || "";
  return base.replace(/\/+$/, "");
};
